import React from "react";
import { Global, Collection, Jobs } from "@sourceflow-uk/sourceflow-sdk";
import { SourceFlowHead } from "@sourceflow-uk/sourceflow-head";
import metaObject from "@/.sourceflow/metadata.json";
import sourceflowEnums from "@/sourceflow.enums";
import MarqueeSlider from "@/components/MarqueeSlider";
import EditableImage from "@/components/EditableImage";

import SubBanner from "@/components/SubBanner";
import FooterWave from "@/public/site-assets/svg/footer-wave.svg";
import BenefitsAtTradeWind from "components/BenefitsAtTradeWind";
import LatestJobs from "components/LatestJobs";
import FocusConsultant from "components/FocusConsultant";
import FocusTextTab from "components/FocusTextTab";

import Wave5 from "@/public/site-assets/svg/wave-5.svg";

import { router } from "@/routes";
import { useLocale } from "@/hooks/useLocale";
/**
 *
 * @param global
 * @param meta
 * @returns {JSX.Element}
 * @constructor
 */
export default function TradewindCareers({
  global,
  meta,
  life_at_tradewind_images,
  benefits_at_tradewind_recruitment,
  jobs,
}) {
  const locale = useLocale();

  return (
    <>
      <SourceFlowHead
        metaObject={metaObject}
        title={meta.title}
        description={meta.description}
        canonical={meta.canonical}
      />
      <div className="bg-light-white">
        <SubBanner
          global={global}
          pathPrefix={`about_us.tradewind_careers.page.sub_banner`}
          heading={`Tradewind Careers`}
          content={
            <p>
              Our people are the absolute best in the market and we’re proud to
              be the employer of choice within the education recruitment
              industry.
            </p>
          }
          breadcrumb_title={
            <>
              <span>About us</span>
              <span className="active">Tradewind Careers</span>
            </>
          }
          wave_color={`light-grey`}
        />
        <MarqueeSlider
          global={global}
          pathPrefix={`about_us.tradewind_careers.page.marquee_slider`}
          content={
            <>
              <p>
                Across LinkedIn and our social media channels we have become
                synonymous with our hashtag
                <strong>#OurPeopleMatterMost</strong>, and that’s because they
                really do. As a Sunday Times Top 100 Best Companies to Work For
                (for the fourth year running!) agency, this achievement is a
                direct reflection on how just well we continually strive to
                treat our staff.
              </p>
            </>
          }
          post={life_at_tradewind_images}
          heading={`Life at Tradewind`}
          className={`tradewind-careers-page py-5`}
        />
        <div className="pt-4"></div>
        <div>
          <FooterWave />
        </div>
        <BenefitsAtTradeWind
          global={global}
          pathPrefix={`about_us.tradewind_careers.page.benefits_at_tradewind`}
          content={
            <>
              <p>
                We’re always on the look-out for exceptional talent across all
                of our teams and departments, including:
              </p>
            </>
          }
          heading={`The benefits of working at Tradewind Subs`}
          post={benefits_at_tradewind_recruitment}
          className="py-5 py-lg-0"
        />
        <div className="wave-with-bg-image position-relative">
          <div className="top-wave position-absolute z-index-1">
            <Wave5 />
          </div>
          {/* <div className="position-absolute image-wrapper">
            <EditableImage
              className={``}
              img={{
                path: `about_us.tradewind_careers.page.image.1`,
                src: `${"/images/placeholders/reading-guy-placeholder.jpg"}`,
              }}
              size={"2000x"}
              alt={``}
              height={`100%`}
            />
          </div> */}

          <FocusConsultant
            global={global}
            pathPrefix={`about_us.tradewind_careers.page.focus_consultant`}
            heading={`Contact Daniela today`}
            content={
              <>
                <p>For an informal chat on what it’s like to work here.</p>
              </>
            }
            button_cta_title={`eamonn.molloy@twsubs.com`}
            button_cta_link={`mailto:eamonn.molloy@twsubs.com`}
            imageURL={`/images/placeholders/dani-placeholder.png`}
            className="position-relative z-index-1"
          />
          {/* <div className="position-relative">
            <div id="impact-academy"></div>
          </div>
          <FocusTextTab
            global={global}
            pathPrefix={`about_us.tradewind_careers.page.focus_text_tab`}
            heading={`Impact Academy`}
            content={
              <>
                <p>
                  Join the IMPACT Academy promotion program to become the best
                  education recruitment leader for our market leading agency!
                  IMPACT Academy is a comprehensive 12-month training program
                  delivered by our highly skilled team, external sales trainers
                  and education senior leaders, where you can learn how to
                  effectively recruit candidates and make placements within
                  educational settings.
                </p>
                <p>
                  <strong>
                    On day one, our new starters are enrolled into the IMPACT
                    Academy and will be supported every step of the way by your
                    team, manager and a personal mentor.
                  </strong>
                </p>
              </>
            }
            button_cta_title={`Find out more`}
            button_cta_link={`/the-impact-academy`}
            imageURL={`/images/placeholders/impact-academy.png`}
            video={"https://www.youtube.com/watch?v=VxbxhM_edMo"}
          /> */}
        </div>
        <LatestJobs
          global={global}
          pathPrefix={`about_us.tradewind_careers.page.latest_jobs`}
          heading={`Our latest internal roles`}
          post={jobs}
          className="py-5 tradewind-careers"
        />
        <div className="pt-5">
          <FooterWave />
        </div>
      </div>
    </>
  );
}

/**
 *
 * @returns {Promise<{props: {meta: {description: string, canonical: string, title: string}, jobs: *, global}}>}
 */
export async function getStaticProps() {
  const global = (await Global()).toJson();
  const life_at_tradewind_images = (
    await Collection(`life_at_tradewind_images`)
  ).getItems();
  const benefits_at_tradewind_recruitment = (
    await Collection(`benefits_at_tradewind_recruitment`)
  ).getItems();

  const jobs = (await Jobs())
    // .filter(function (job) {
    //     return job.categories
    //         // Pull all internal jobs
    //         .find((cat) => cat.name == "Internal");
    // })

    .filter((job) => {
      return job.categories
        .find((cat) => cat.id == "8ea7a115-9693-4b5a-99a8-d98cdbc06797")
        ?.values?.map((val) => val.id)
        ?.includes("015ec67b-9b3e-445b-856b-226640ff008e");
    })
    .filter(function (job) {
      return new Date(job?.expires_at) >= new Date();
    })
    .getItems();

  const routerKey = "about.tradewind_careers";

  return {
    props: {
      global,
      meta: {
        title: "Tradewind Careers | Tradewind Subs",
        description: `${sourceflowEnums.seo.genericDescription}`,
        // canonical: sourceflowEnums.seo.baseURL,
        canonical: `${sourceflowEnums.seo.baseURL}${router[routerKey]["en"]}`,
        // alternate: { link: router[routerKey]["en"], lang: "en" },
      },
      life_at_tradewind_images,
      benefits_at_tradewind_recruitment,
      jobs,
    },
  };
}

// -- Reference -- //
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflow-head
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflowtext
// https://github.com/sourceflow-uk/components/pkgs/npm/job-search
